module.exports = __webpack_public_path__ + "img/sync-hanging.172e12f2.svg";